module.exports = __webpack_public_path__ + "media/images/flags/16/Vatican-City-c1dd1a427b597969057a12e81a1a2348.png";